/* eslint-disable default-param-last */
import { ApiInstanceConfig, apiInstance } from './client';
import { getAuthToken } from '../authHelpers';

/**
 * Higher order builder for authenticated apis
 */
const authApiInstance = (config: ApiInstanceConfig = {}, addBearer = true) => {
  const api = apiInstance(config);
  api.addAsyncRequestTransform((request) => async () => {
    const token = await getAuthToken();
    const header = addBearer ? `Bearer ${token}` : token;
    request.headers = Object.assign(api.headers, { Authorization: header });
  });

  return api;
};

/**
 * Higher order builder for authenticated apis
 */
export const authApiBuilder =
  ({ url: rawUrl, ...config }: ApiInstanceConfig = {}, addBearer?: boolean) =>
  (originSuffix?: string) => {
    let url = rawUrl;
    if (originSuffix) {
      url += `/${originSuffix}`;
    }
    return authApiInstance({ url, ...config }, addBearer);
  };
